import "./carousel.css"

function ContacthosptiComponent() {
    return (
        <div className="container-xxl py-5">
            <div className="container">
                <div className="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: '600px' }}>
                    <h1>The debuggers team members</h1>
                </div>
                <div className="row g-4 justify-content-center">
                    <div className="col-lg-2 col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="team-item position-relative rounded overflow-hidden">
                            <div className="overflow-hidden">
                                <img className="img-fluid" src="houssem.png" alt="houssem" />
                            </div>
                            <div className="team-text bg-light text-center p-4">
                                <h5>Houssem Kharroubi</h5>
                                <p className="text-primary">Full Stack Web Developer</p>
                                <div className="team-social text-center">
                                    <a className="btn btn-square" href><i className="fab fa-github" /></a>
                                    <a className="btn btn-square" href><i className="fab fa-google" /></a>
                                    <a className="btn btn-square" href><i className="fab fa-linkedin" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="team-item position-relative rounded overflow-hidden">
                            <div className="overflow-hidden">
                                <img className="img-fluid" src="oussama.png" alt="oussama" />
                            </div>
                            <div className="team-text bg-light text-center p-4">
                                <h5>Oussema Gadria</h5>
                                <p className="text-primary">Full Stack Web Developer</p>
                                <div className="team-social text-center">
                                    <a className="btn btn-square" href><i className="fab fa-github" /></a>
                                    <a className="btn btn-square" href><i className="fab fa-google" /></a>
                                    <a className="btn btn-square" href><i className="fab fa-linkedin" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="team-item position-relative rounded overflow-hidden">
                            <div className="overflow-hidden">
                                <img className="img-fluid" src="nour.png" alt="nour" />
                            </div>
                            <div className="team-text bg-light text-center p-4">
                                <h5>Nour Makni</h5>
                                <p className="text-primary">Full Stack Web Developer</p>
                                <div className="team-social text-center">
                                    <a className="btn btn-square" href><i className="fab fa-github" /></a>
                                    <a className="btn btn-square" href><i className="fab fa-google" /></a>
                                    <a className="btn btn-square" href><i className="fab fa-linkedin" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="team-item position-relative rounded overflow-hidden">
                            <div className="overflow-hidden">
                                <img className="img-fluid" src="hamza.png" alt="hamza" />
                            </div>
                            <div className="team-text bg-light text-center p-4">
                                <h5>Hamza Hafaiedh</h5>
                                <p className="text-primary">Full Stack Web Developer</p>
                                <div className="team-social text-center">
                                    <a className="btn btn-square" href><i className="fab fa-github" /></a>
                                    <a className="btn btn-square" href><i className="fab fa-google" /></a>
                                    <a className="btn btn-square" href><i className="fab fa-linkedin" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-4 wow fadeInUp" data-wow-delay="0.7s">
                        <div className="team-item position-relative rounded overflow-hidden">
                            <div className="overflow-hidden">
                                <img className="img-fluid" src="yasser.png" alt="yasser" />
                            </div>
                            <div className="team-text bg-light text-center p-4">
                                <h5>Yasser Ben Ouhiba</h5>
                                <p className="text-primary">Full Stack Web Developer</p>
                                <div className="team-social text-center">
                                    <a className="btn btn-square" href><i className="fab fa-github" /></a>
                                    <a className="btn btn-square" href><i className="fab fa-google" /></a>
                                    <a className="btn btn-square" href><i className="fab fa-linkedin" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContacthosptiComponent;